export const TIME_PICKER_MODES = {
    DEFAULT: "default",
    ONLY_HOURS: "onlyHours"
}